import { useLayoutEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

const scrollTops = new Map<string, number>()
const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined
const reloaded = navigation?.type === 'reload'
const reloadPath = reloaded ? window.location.pathname : ''
let reloadScrollDone = false
let reloadHashPending = reloaded

export function renewalScrollKey(location: { key?: string; pathname: string; search: string; hash: string }) {
  return location.key || `${location.pathname}${location.search}${location.hash}`
}

/** 새로고침으로 연 그 주소에서만, 첫 화면이 해시 위치로 내려가지 않게 한다. */
export function consumeReloadHashSkip(pathname: string) {
  if (!reloadHashPending || pathname !== reloadPath) return false
  reloadHashPending = false
  return true
}

export function hasRenewalScroll(key: string) {
  return scrollTops.has(key)
}

export function useRenewalScrollRestore() {
  const location = useLocation()
  const history = useHistory()
  const key = renewalScrollKey(location)

  useLayoutEffect(() => {
    const previous = window.history.scrollRestoration
    window.history.scrollRestoration = 'manual'
    return () => {
      window.history.scrollRestoration = previous
    }
  }, [])

  useLayoutEffect(() => {
    const root = document.querySelector('.renewal-root')
    if (!root) return
    if (reloaded && !reloadScrollDone) {
      reloadScrollDone = true
      root.scrollTop = 0
      if (location.hash) history.replace({ pathname: location.pathname, search: location.search })
      requestAnimationFrame(() => {
        if (root.isConnected) root.scrollTop = 0
      })
    } else {
      const saved = scrollTops.get(key)
      const hashTarget = location.hash.length > 1 ? document.getElementById(location.hash.slice(1)) : null
      if (saved != null) root.scrollTop = saved
      else if (hashTarget) hashTarget.scrollIntoView({ block: 'start' })
      else root.scrollTop = 0
    }
    const save = () => scrollTops.set(key, root.scrollTop)
    root.addEventListener('scroll', save, { passive: true })
    root.addEventListener('click', save, true)
    return () => {
      root.removeEventListener('scroll', save)
      root.removeEventListener('click', save, true)
    }
  }, [history, key, location.hash, location.pathname, location.search])
}
